import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { Button } from '@/shared/ui';

interface OverviewNoticeProps {
  readonly message: string;
  /** 본인인증 전 계정이면 온보딩으로 보낸다 — 아니면 null. */
  readonly onboardingPath: string | null;
  readonly onRetry: () => void;
}

/** 홈의 읽기 실패 안내 — 계정 상태 때문이면 온보딩 링크를, 일시 오류면 다시 시도를 준다. */
export const OverviewNotice = ({
  message,
  onboardingPath,
  onRetry,
}: OverviewNoticeProps): ReactElement => (
  <div
    role="alert"
    className="flex flex-wrap items-center justify-between gap-4 border-l-2 border-destructive bg-destructive/5 px-5 py-4"
  >
    <p className="text-sm text-destructive">{message}</p>
    {onboardingPath !== null ? (
      <Link
        to={onboardingPath}
        className="text-sm font-semibold underline underline-offset-4 hover:no-underline"
      >
        인증 마치러 가기
      </Link>
    ) : (
      <Button variant="outline" size="sm" onClick={onRetry}>
        다시 시도
      </Button>
    )}
  </div>
);
